module.exports = __webpack_public_path__ + "img/lentille.5ba0c313.jpg";